// import React, { useEffect, useState } from "react";
// import { Container, Row, Col, Nav } from "react-bootstrap";
// import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
// import { FiLogOut, FiMenu } from "react-icons/fi";
// import {
//   FaAlignJustify,
//   FaFileAlt,
//   FaFileMedicalAlt,
//   FaFileArchive,
//   FaBook,
// } from "react-icons/fa";
// import { BsFileEarmarkText } from "react-icons/bs";
// import { AiFillFileText } from "react-icons/ai";

// import Swal from "sweetalert2";
// import Loader from "../loader";
// import "../../css/client/clientSidebarLayout.css";

// const ClientSidebarLayout = () => {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const [showLoader, setShowLoader] = useState(false);
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
//   const [showSidebar, setShowSidebar] = useState(false); // For mobile toggle

//   const isDashboard = location.pathname === "/client-dashboard";

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 768);
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const logout = async () => {
//     const result = await Swal.fire({
//       title: "Are you sure?",
//       text: "Are you sure you want to logout",
//       icon: "question",
//       showCancelButton: true,
//       confirmButtonText: "Yes, logout!",
//       width: "320px",
//       customClass: {
//         popup: "custom-swal-popup",
//         confirmButton: "btn btn-sm btn-danger",
//         cancelButton: "btn btn-sm btn-secondary",
//       },
//     });

//     if (result.isConfirmed) {
//       setShowLoader(true);
//       setTimeout(() => {
//         localStorage.removeItem("tk");
//         localStorage.removeItem("cn");
//         localStorage.removeItem("lo");
//         navigate("/client");
//         setShowLoader(false);
//       }, 3000);
//     }
//   };

//   const shouldShowSidebar = !isMobile && isDashboard;

//   return (
//     <div
//       className={`client-layout-wrapper ${
//         shouldShowSidebar ? "with-sidebar" : "no-sidebar"
//       }`}
//     >
//       {/* Hamburger for mobile */}
//       {isMobile && (
//         <button
//           className="hamburger-btn btn btn-light position-fixed top-0 start-0 m-2 "
//           onClick={() => setShowSidebar(!showSidebar)}
//         >
//           <FiMenu size={20} />
//         </button>
//       )}

//       {/* Sidebar */}
//       <div
//         className={`sidebar-panel ${
//           shouldShowSidebar || (isMobile && showSidebar) ? "visible" : "hidden"
//         }`}
//       >
//         <div className="sidebar-client p-3 shadow-sm d-flex flex-column h-100">
//           <div className="sidebar-header mb-3 text-center text-white">
//             <h4>CA STUDIO</h4>
//             <hr />
//           </div>

//           <Nav className="flex-column text-start">
//             <NavLink to="/client-form-24Q" className="nav-link text-white">
//               <FaAlignJustify className="me-2" />
//               Form 24Q
//             </NavLink>
//             <NavLink to="/client-form-26Q" className="nav-link text-white">
//               <FaFileMedicalAlt className="me-2" />
//               Form 26Q
//             </NavLink>
//             <NavLink to="/client-form-27EQ" className="nav-link text-white">
//               <FaFileArchive className="me-2" />
//               Form 27EQ
//             </NavLink>
//             <NavLink to="/client-form-GSTR1" className="nav-link text-white">
//               <FaFileAlt className="me-2" />
//               Form GSTR-1
//             </NavLink>
//             <NavLink to="/client-form-GSTR-R7" className="nav-link text-white">
//               <FaBook className="me-2" />
//               Form GSTR-R-7
//             </NavLink>
//           </Nav>

//           <div className="mt-auto text-center">
//             <hr className="text-white" />
//             <button
//               className="btn logout-btn text-white w-100 d-flex align-items-center justify-content-center gap-2"
//               onClick={logout}
//             >
//               <FiLogOut />
//               Logout
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Main Content */}
//       <div className="client-content-area p-3">
//         {!isDashboard && !isMobile && (
//           <div className="d-flex justify-content-end mb-3">
//             <button
//               className="btn btn-outline-secondary"
//               onClick={() => navigate("/client-dashboard")}
//             >
//               Close
//             </button>
//           </div>
//         )}
//         <Outlet />
//       </div>

//       {showLoader && <Loader show={showLoader} />}
//     </div>
//   );
// };

// export default ClientSidebarLayout;

import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Nav } from "react-bootstrap";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { getImage } from "../../utils/admin/misc";
import "../../css/admin/sidebar.css";
import { FiLogOut } from "react-icons/fi";
import {
  FaAlignJustify,
  FaFileAlt,
  FaFileMedicalAlt,
  FaFileArchive,
  FaBook,
} from "react-icons/fa";
import { BsPrinter } from "react-icons/bs";
import Swal from "sweetalert2";
import Loader from "../loader";

const ClientSidebarLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const sidebarRef = useRef(null);
  const navigate = useNavigate();
  let clientInfo = JSON.parse(localStorage.getItem("clientInfo"));

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isMobile = window.innerWidth < 768;

      if (
        isMobile &&
        sidebarOpen &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        closeSidebar();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [sidebarOpen]);

  const logout = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to logout",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, logout!",
      width: "320px",
      customClass: {
        popup: "custom-swal-popup",
        confirmButton: "btn btn-sm btn-danger",
        cancelButton: "btn btn-sm btn-secondary",
      },
    });

    if (result.isConfirmed) {
      setShowLoader(true);
      setTimeout(() => {
        localStorage.removeItem("tk");
        localStorage.removeItem("cn");
        localStorage.removeItem("lo");
        localStorage.removeItem("clientInfo");
        localStorage.removeItem("ui");
        navigate("/");
        setShowLoader(false);
      }, 3000);
    }
  };

  return (
    <>
      <Container fluid>
        <button className="mobile-toggle-btn" onClick={toggleSidebar}>
          ☰
        </button>

        <Row className="min-vh-100">
          <Col
            md={3}
            ref={sidebarRef}
            className={`sidebar p-3 shadow-sm d-flex flex-column ${
              sidebarOpen ? "open" : ""
            }`}
          >
            <div className="sidebar-header text-center ">
              {/* <h4>CA STUDIO</h4> */}
              <div>
                <h4>{clientInfo?.client?.cn}</h4>
              </div>
              <div>
                <span>{clientInfo?.client?.ta}</span>
              </div>
              <hr />
            </div>

            <Nav className="flex-column text-start">
              {clientInfo?.client?.i24 === 1 && (
                <NavLink
                  to="/client-form-24Q"
                  className="nav-link text-white"
                  style={{ fontWeight: 500 }}
                  onClick={closeSidebar}
                  title="FORM NO. 24Q FOR SALARIED EMPLOYEE"
                >
                  <FaAlignJustify className="me-2" />
                  Form 24Q
                </NavLink>
              )}
              {clientInfo?.client?.i26 === 1 && (
                <NavLink
                  to="/client-form-26Q"
                  className="nav-link text-white"
                  style={{ fontWeight: 500 }}
                  onClick={closeSidebar}
                  title="FORM NO. 26Q FOR OTHER THAN SALARIED EMPLOYEE"
                >
                  <FaFileMedicalAlt className="me-2" />
                  Form 26Q
                </NavLink>
              )}
              {clientInfo?.client?.i27 === 1 && (
                <NavLink
                  to="/client-form-27EQ"
                  className="nav-link text-white"
                  style={{ fontWeight: 500 }}
                  onClick={closeSidebar}
                  title="FORM 27EQ IS USED FOR REPORTING TAX COLLECTED AT SOURCE (TCS) ON SPECIFIED GOODS."
                >
                  <FaFileArchive className="me-2" />
                  Form 27EQ
                </NavLink>
              )}
              {clientInfo?.client?.ig1 === 1 && (
                <NavLink
                  to="/client-form-GSTR1"
                  className="nav-link text-white"
                  style={{ fontWeight: 500 }}
                  onClick={closeSidebar}
                  title="GSTR-1 FOR OUTWARD SUPPLIES OF GOODS AND SERVICES DETAILS."
                >
                  <FaFileAlt className="me-2" />
                  Form GSTR-1
                </NavLink>
              )}
              {clientInfo?.client?.ig7 === 1 && (
                <NavLink
                  to="/client-form-GSTR7"
                  className="nav-link text-white"
                  style={{ fontWeight: 500 }}
                  onClick={closeSidebar}
                  title="GSTR 7 FOR GOVT. DEDUCTOR"
                >
                  <FaBook className="me-2" />
                  Form GSTR-R7
                </NavLink>
              )}

              <NavLink
                to="/upload-document"
                className="nav-link text-white"
                style={{ fontWeight: 500 }}
                onClick={closeSidebar}
              >
                <FaBook className="me-2" />
                Upload Document
              </NavLink>
              {/* <NavLink
                to="/print-emp-report"
                className="nav-link text-white"
                onClick={closeSidebar}
              >
                <BsPrinter className="me-2" />
                Employee Report
              </NavLink> */}
            </Nav>

            <div className="mt-auto text-center">
              <hr className="text-white" />
              <button
                style={{ fontWeight: 500 }}
                className="btn logout-btn  w-100 d-flex align-items-center justify-content-center gap-2"
                onClick={() => logout()}
              >
                <FiLogOut />
                Logout
              </button>
            </div>
          </Col>

          {/* Main Content */}
          <Col md={10} className=" content-area">
            <Outlet />
          </Col>
        </Row>
      </Container>
      {showLoader ? <Loader show={showLoader} /> : null}
    </>
  );
};

export default ClientSidebarLayout;
